import { Zap } from 'lucide-react';

export const TokenCounter = ({ tokenUsage }) => (
  <div className="flex items-center justify-center gap-1.5 mt-2 text-[10px] font-medium text-slate-400 dark:text-slate-500 select-none">
    <Zap size={12} className="text-[#36a852]" />
    <span>{tokenUsage.toLocaleString()} tokens consumed this session</span>
  </div>
);
